import type {AmenityConfig} from "./amenity-config";

/** Unified facility list endpoint (all amenity types). */
export const UNIFIED_FACILITIES_LIST_PATH = "property_amenities";

export function buildPropertyAmenitiesListFilter(
  config: AmenityConfig,
  extra?: Record<string, string | number | null | undefined>,
) {
  return {
    ...extra,
    amenity_type: config.type,
  };
}
